import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { COBRANZAS_NUEVO, COBRANZAS_REPORTES } from 'constants/codigosTransacciones'

import NuevaPage from './nueva'
import ReportesPage from './reportes'

export default function CobranzasPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${COBRANZAS_NUEVO}`} component={NuevaPage} />
        <Route path={`/${COBRANZAS_REPORTES}`} component={ReportesPage} />
      </Switch>
    </Suspense>
  )
}
